import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, TextareaAutosize, TextField } from '@mui/material';
import axios from 'axios';

import api from '../../../utils/axiosInstance';

import styles from '../../Form/Form.module.css';

export default function ComplexQuestionEdit(props) {
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [fileContent, setFileContent] = useState(null);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    props.setIsUploadingFile(true);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post('validateExcelQuestion', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      props.setSelectedFileSelectQuestion((prev) => ({
        ...prev,
        [props.question.id]: file,
      }));
      props.setQuestion((prev) => ({
        ...prev,
        customOptions: response.data.filas,
        file: file,
      }));
      setUploadSuccess('Archivo válido ✅');
      setUploadError('');
      setFileContent(null);
    } catch (err) {
      props.setSelectedFileSelectQuestion((prev) => {
        const updated = { ...prev };
        delete updated[props.question.id];
        return updated;
      });
      setUploadSuccess('');
      setUploadError(
        err.response?.data?.message || 'Ocurrió un error al validar el archivo'
      );

      const reader = new FileReader();
      reader.onload = function (e) {
        setFileContent(e.target.result);
      };
      reader.readAsText(file);
    } finally {
      props.setIsUploadingFile(false);
    }
  };

  const handleRemoveFile = () => {
    props.setSelectedFileSelectQuestion((prev) => {
      const updated = { ...prev };
      delete updated[props.question.id];
      return updated;
    });

    props.setQuestion((prev) => {
      const updated = { ...prev };
      delete updated.file;
      delete updated.customOptions; // ✅ También limpia customOptions
      return updated;
    });
    
    setUploadSuccess('');
    setUploadError('');
    setFileContent(null);
  };

  return (
    <div className={styles.top}>
      <div className={styles.input} style={{ marginTop: '1rem' }}>
        <label htmlFor={`excel-upload-complex-edit-${props.question.id}`}>
          <input
            accept=".xlsx"
            id={`excel-upload-complex-edit-${props.question.id}`}
            type="file"
            hidden
            onChange={handleFileUpload}
          />
          {(!props.question.file && !props.question.customOptions?.length) ||
          props.errorMessage.selectedFileSelectQuestionError ? (
            <Button
              variant="outlined"
              component="span"
              color={
                props.errorMessage.selectedFileSelectQuestionError
                  ? 'error'
                  : 'primary'
              }
              sx={{
                borderColor: props.errorMessage.selectedFileSelectQuestionError
                  ? 'red'
                  : undefined,
              }}
            >
              Subir archivo Excel
            </Button>
          ) : null}
          {props.errorMessage.selectedFileSelectQuestionError && (
            <p style={{ color: 'red', marginTop: '0.3rem' }}>
              {props.helperText.selectedFileSelectQuestionHelpertext}
            </p>
          )}
        </label>

        {(props.question.file || props.question.customOptions?.length > 0) && (
          <div
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ marginRight: '1rem', color: '#333' }}>
              {props.question.file
                ? <>Archivo: <strong>{props.question.file.name}</strong></>
                : <><strong>{props.question.customOptions.length}</strong> opciones cargadas desde Excel</>
              }
            </span>
            <IconButton size="small" onClick={handleRemoveFile}>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
        {props.isUploadingFile && (
          <p style={{ color: '#888', marginTop: '0.5rem' }}>
            Procesando archivo...
          </p>
        )}
        {uploadError && (
          <p style={{ color: 'red', marginTop: '0.5rem' }}>{uploadError}</p>
        )}
        {uploadSuccess && (
          <p style={{ color: 'green', marginTop: '0.5rem' }}>{uploadSuccess}</p>
        )}
      </div>
    </div>
  );
}